/**
 * NavGuardContext — garde de navigation légère (routeur déclaratif).
 * Une vue « brouillon » enregistre une garde ; les éléments de navigation de la barre
 * latérale / recherche appellent `confirmLeave()` avant de naviguer. Si l'utilisateur
 * confirme, la garde exécute son nettoyage (ex. suppression du brouillon).
 */
import { createContext, useContext, useRef, useCallback } from 'react';

const NavGuardContext = createContext(null);

export function NavGuardProvider({ children }) {
  const guardRef = useRef(null); // { message, onConfirm }

  const setGuard = useCallback((g) => { guardRef.current = g; }, []);

  const confirmLeave = useCallback(() => {
    const g = guardRef.current;
    if (!g) return true;
    const ok = window.confirm(g.message || 'Abandonner ?');
    if (ok) { guardRef.current = null; g.onConfirm?.(); }
    return ok;
  }, []);

  return (
    <NavGuardContext.Provider value={{ setGuard, confirmLeave }}>
      {children}
    </NavGuardContext.Provider>
  );
}

export function useNavGuard() {
  return useContext(NavGuardContext) || { setGuard: () => {}, confirmLeave: () => true };
}
